import { type MutableRefObject, useEffect, useState } from 'react';

type UseScrollableShowTopProps = {
    startScrollableAreaRef: MutableRefObject<HTMLDivElement>;
    scrollableRef: MutableRefObject<HTMLDivElement>;
};

const useScrollableShowTop = ({
    startScrollableAreaRef,
    scrollableRef
}: UseScrollableShowTopProps) => {
    const [showTop, setShowTop] = useState(false);
    const scrollContainer = (scrollableRef as MutableRefObject<HTMLDivElement>)?.current;
    const handleTopClick = () => {
        scrollContainer.scrollTop = 0;
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setShowTop(scrollContainer?.clientHeight > 0 && !entry.isIntersecting);
            },
            { threshold: 1, root: startScrollableAreaRef?.current?.parentElement }
        );

        if (startScrollableAreaRef?.current) {
            observer.observe(startScrollableAreaRef.current);
        }

        return () => {
            setShowTop(false);
            if (startScrollableAreaRef?.current) {
                observer.unobserve(startScrollableAreaRef.current);
            }
        };
    }, [startScrollableAreaRef, scrollContainer?.clientHeight]);

    return { handleTopClick, showTop };
};

export default useScrollableShowTop;
